<template>
    <role-manage-edit/>
</template>

<script>
    import RoleManageEdit from "_private/components/super/systemSetting/roleManage/Edit";

    export default {
        components: {
            RoleManageEdit
        }
    };
</script>
